import { SVGFC } from '@repo/toolkit/types'

const AddUserTwoIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_12122_579607)">
        <path
          d="M11.9749 11.8694C13.0553 11.251 13.7935 10.0996 13.7935 8.76812C13.7935 6.79027 12.1844 5.18115 10.2065 5.18115C8.22867 5.18115 6.61955 6.79027 6.61955 8.76812C6.61955 10.0996 7.35775 11.251 8.43814 11.8694C5.73575 12.5789 3.75 14.8638 3.75 17.5719V18.4529C3.75 18.6509 3.91071 18.8116 4.10871 18.8116C4.30671 18.8116 4.46741 18.6509 4.46741 18.4529V17.5719C4.46738 14.6959 7.04212 12.3551 10.2065 12.3551C13.1846 12.3551 15 14 15.2828 16.1205V17.0015C15.2828 17.1995 15.4435 17.3602 15.6415 17.3602C15.8395 17.3602 16.0002 17.1995 16.0002 17.0015V16.1205C16.0002 14.5 14.5 12.3551 11.9749 11.8694ZM7.33697 8.76812C7.33697 7.18556 8.62396 5.89857 10.2065 5.89857C11.7891 5.89857 13.0761 7.18556 13.0761 8.76812C13.0761 10.3507 11.7891 11.6377 10.2065 11.6377C8.62396 11.6377 7.33697 10.3507 7.33697 8.76812Z"
          fill={color}
          stroke={color}
          strokeWidth="0.2"
        />
        <path
          d="M16.8051 11.88C17.5828 11.3656 18.0979 10.4861 18.0979 9.48674C18.0979 7.90419 16.8109 6.61719 15.2283 6.61719C15.0303 6.61719 14.8696 6.77789 14.8696 6.97589C14.8696 7.17389 15.0303 7.3346 15.2283 7.3346C16.4149 7.3346 17.3805 8.30022 17.3805 9.48677C17.3805 10.6733 16.4149 11.6389 15.2283 11.6389C15.0303 11.6389 14.8696 11.7997 14.8696 11.9977C14.8696 12.1957 15.0303 12.3563 15.2283 12.3563C17.6021 12.3563 19.5326 14.1404 19.5326 16.3342V17.0193C19.5326 17.2173 19.6934 17.378 19.8914 17.378C20.0894 17.378 20.2501 17.2173 20.2501 17.0193V16.3342C20.2501 14.261 18.8038 12.4998 16.8051 11.88Z"
          fill={color}
          stroke={color}
          strokeWidth="0.2"
        />
        <path
          d="M16 18.5C16 18.4402 16.0237 18.3829 16.066 18.3407C16.1082 18.2984 16.1656 18.2747 16.2253 18.2747H17.2747V17.2253C17.2747 17.1656 17.2984 17.1082 17.3407 17.066C17.3829 17.0237 17.4402 17 17.5 17C17.5598 17 17.6171 17.0237 17.6593 17.066C17.7016 17.1082 17.7253 17.1656 17.7253 17.2253V18.2747H18.7747C18.8344 18.2747 18.8918 18.2984 18.934 18.3407C18.9763 18.3829 19 18.4402 19 18.5C19 18.5598 18.9763 18.6171 18.934 18.6593C18.8918 18.7016 18.8344 18.7253 18.7747 18.7253H17.7253V19.7747C17.7253 19.8344 17.7016 19.8918 17.6593 19.934C17.6171 19.9763 17.5598 20 17.5 20C17.4402 20 17.3829 19.9763 17.3407 19.934C17.2984 19.8918 17.2747 19.8344 17.2747 19.7747V18.7253H16.2253C16.1656 18.7253 16.1082 18.7016 16.066 18.6593C16.0237 18.6171 16 18.5598 16 18.5Z"
          fill={color}
          stroke={color}
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_12122_579607">
          <rect width="16.5" height="16.5" fill={color} transform="translate(3.75 3.75)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AddUserTwoIcon
